import { useEffect, useState } from 'react';
import { ensureCanonicalSpaHost } from '../../config/environments';

/**
 * Production (and packaged QA/dev_server) SPA must run on the matrix host.
 * If a production build is opened on cantest/Dev, bounce to candorsys.com
 * before auth UI mounts — prevents Dev return URLs and broken cookie sessions.
 */
export default function CanonicalSpaHostGate({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // ***** Code Start BH15092026_1445 - Canonical SPA host gate
    if (ensureCanonicalSpaHost()) {
      return undefined;
    }
    setReady(true);
    return undefined;
    // ***** Code End BH15092026_1445
  }, []);

  if (!ready) {
    return (
      <div
        style={{
          minHeight: '40vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          color: '#64748b',
          fontSize: 14,
        }}
      >
        Redirecting to secure sign-in host…
      </div>
    );
  }

  return children;
}
